import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316M8.667 10a8.001 8.001 0 0 1 14.549 0z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M24.446 10q.848-.82 1.142-.926c.346-.126.86-.173 1.042.33a.58.58 0 0 1-.089.596zM5.458 10a.58.58 0 0 1-.089-.596c.184-.503.697-.456 1.043-.33q.293.107 1.141.926zM16 4.667q-.667-1.432-.667-1.8c0-.368.131-.867.667-.867.535 0 .666.499.666.867q0 .367-.666 1.8m1.736.175q-.356-1.539-.278-1.899c.076-.36.308-.82.832-.71.524.112.549.627.472.987q-.076.36-1.026 1.622m1.686.53q-.054-1.58.09-1.918c.144-.34.46-.747.952-.538.493.21.42.72.275 1.059q-.144.339-1.317 1.396m1.526.846q.274-1.556.486-1.857c.211-.302.605-.635 1.043-.327.439.307.26.79.05 1.092q-.212.3-1.58 1.092m1.34 1.152q.567-1.475.832-1.73c.265-.256.715-.508 1.087-.123.372.386.104.826-.16 1.082q-.266.256-1.758.77m1.067 1.38q.861-1.323 1.174-1.519c.312-.195.804-.348 1.088.106s-.07.83-.382 1.025q-.311.195-1.88.388m-14.71 0q-1.569-.193-1.88-.388c-.313-.195-.666-.57-.382-1.025.283-.454.776-.301 1.088-.106q.313.195 1.173 1.52M9.71 7.37q-1.492-.515-1.758-.77c-.265-.257-.532-.697-.16-1.083.372-.385.821-.133 1.086.123q.265.255.832 1.73m1.34-1.152q-1.366-.79-1.578-1.092c-.21-.302-.39-.785.05-1.093.438-.307.831.026 1.043.328q.21.302.486 1.857m1.526-.847q-1.172-1.057-1.317-1.396c-.144-.34-.218-.85.275-1.059s.809.199.953.538q.143.339.09 1.917m1.687-.529q-.95-1.262-1.026-1.622c-.077-.36-.052-.875.472-.986.523-.111.755.349.832.709q.076.36-.278 1.9",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMwi = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMwi_default = SvgFlagMwi;

export { FlagMwi_default as default };
